module.exports = __webpack_public_path__ + "static/media/background.e6403a3a.mp3";